<template>
  <div class="diy-notice">
  <van-notice-bar :leftIcon="params.icon" :text="params.text" :color="itemStyle.textColor" :background="itemStyle.background" :style="'padding:'+itemStyle.paddingTop+'px 0px'" :scrollable="true" />
</div>
</template>

<script>
import { NoticeBar } from 'vant';
import Vue from "vue";
Vue.use(NoticeBar);
export default {
  props: ["itemIndex", "itemStyle", "params"],
  created(){
  },
  activated() {
  },
  methods:{
    
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
.notice__icon {
  font-size: 0;
}

.notice__icon img {
  width: 14px;
  height: 7px;
}

.notice__text {
  width: 149px;
  height: 15px;
  padding-left: 2.5px;
}

</style>